export const BOX_REVEAL = `Box salvo e revelado com sucesso, todos os pedidos foram
atualizados`;
export const BOX_NOT_REVEAL = `Ocorreu um problema na revelação do box`;
export const ERROR_BOX_ITEM_DELETE = 'Houve uma falha ao excluir o item do box';
export const NO_CURRENT_BOX =
  'Estamos preparando o box desse mês, logo estará disponível para você.';
